import { render, staticRenderFns } from "./backups.vue?vue&type=template&id=0b7fd620&scoped=true&"
import script from "./backups.vue?vue&type=script&lang=js&"
export * from "./backups.vue?vue&type=script&lang=js&"
import style0 from "./backups.vue?vue&type=style&index=0&id=0b7fd620&prod&scoped=true&lang=css&"
import style1 from "./backups.vue?vue&type=style&index=1&id=0b7fd620&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fd620",
  null
  
)

export default component.exports